import styled from 'styled-components';

import { IS_SMALL } from "~/utils/media";
import { Grid } from '~/components/grid';
import { PdpInfoBlock, PdpInfoItem } from './../pdp.style';

export const QualityWrapper = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8rem;

  ${PdpInfoBlock} {
    margin-bottom: 0;
    padding-right: 4rem;
    color: ${({ theme }) => theme.colors.accentTwo};

    h4 {
      margin-top: 0.2rem;
    }
  }

  ${IS_SMALL} {
    flex-direction: column-reverse;

    ${PdpInfoBlock} {
      padding: 2rem 10vw 0;
      text-align: center;
    }

    ${PdpInfoItem} {
      justify-content: center;
    }
  }
`;

export const QualityImage = styled.img`
  display: block;
  width: 50%;
  object-fit: cover;

  ${IS_SMALL} {
    width: 100%;
    max-width: 70vw;
  }
`;
